import { Component, OnInit, ViewEncapsulation, Injector, ViewChild, Output, EventEmitter } from '@angular/core';
import { appModuleAnimation } from '../../../../../shared/animations/routerTransition';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { PasswordComplexitySetting, AccountServiceProxy, ProfileServiceProxy, MyProfileOutput, ChangePasswordInput, StoreImageOnBlobDto, BlobHelperServiceProxy, UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AppAuthService } from '../../../common/auth/app-auth.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserMenuComponent } from '../user-menu.component';
import { AvatarCollectionService } from '@shared/common/avatarView/avatar-collection.services';
import { FormGroup, NgForm } from '@angular/forms';
import { BreadcrumbItem } from '../../../common/sub-header/sub-header.component';
import { HeaderTitle } from '../../../common/header-title/header-title.model';
import { HeaderTitleService } from '../../../common/header-title/header-title.service';
import { MessageService } from 'abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class MyProfileComponent extends AppComponentBase implements OnInit {
    @ViewChild('myProfileForm', { static: true }) myProfileForm: NgForm;
    @ViewChild('topBarComponentData', { static: true }) topBarComponentData: UserMenuComponent;
    @Output() emitFunctionOfParent: EventEmitter<any> = new EventEmitter<any>();
    showEmail: boolean;
    showModal: boolean;
    currentPassword: string;
    newPassword: string;
    imagePathModal = '';
    confirmPassword: string;
    newEmail: string;
    confirmEmail: string="";
    fileExtension: any;
    imagePath = '';
    logoInput: any;
    pictureImage: any;
    fieldTextType: boolean;
    fieldTextTypeNewPassword: boolean;
    fieldTextTypeNewPasswordConfirm: boolean;

    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();
    checkEmail: boolean;
    myProfileData: MyProfileOutput = new MyProfileOutput();
    encryptPassword: any;
    decPassword: any;
    imageBase64: string;
    selectedAvatarIndex: number;
    isLoading: boolean;
    hide = true;
    clicked = false;
    showPassword = false;
    emailshowModal = false;
    showImgModal = false;
    showImg = true;
    saving = false;
    icon = false;
    tabIndex = 1;
    allowedPhotoFile = ["png", "jpg", "jpeg"];
    isemailValid = false;
    isemailValidationerror = false;
    emailValidator: boolean;
    isEmailNotsame = false;
    iscurrentPassword = false;

    matchPassword: boolean;

    EmailCheck = false;
    isSocialLogincheck: boolean = true;
   
    newEmailId: string = "";
    photoImage = [{ 'id': 1, 'icon': '' }];
    isSocial: boolean = false;
    isSocialNumber = 0;

    socialId: number;
    myEmail: any;
    isImage = false;
    isImagepanel = true;
    isSidebarOpen: boolean = false;

    constructor(injector: Injector,
        private _accountService: AccountServiceProxy,
        private _router: Router,
        private toastr: ToastrService,
        private _appAuthService: AppAuthService,
        private _profileService: ProfileServiceProxy,
        private headerTitleService: HeaderTitleService,
        private _blobHelperServiceProxy: BlobHelperServiceProxy,
        private _messageService: MessageService,
        private _avatarCollectionService: AvatarCollectionService,
        private _userServiceProxy: UserServiceProxy
           ) {
        super(injector);
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.spinnerService.show();
        this.SocialLoginVerify();
        let loggedUserData = localStorage.getItem('MyProfileData');
        let userDetails = JSON.parse(loggedUserData);
        this.myProfileData = userDetails;
        this.myEmail = userDetails.emailAddress;
        this.spinnerService.hide();
        this.imagePath = this.myProfileData.imagePath;
            if(this.imagePath == AppConsts.BackgroundImagephoto)
            {   
                this.imagePath = "";
            }
            if (this.myProfileData.fullName != null) {
                let splitted = this.myProfileData.fullName.split(' ');
                for (let i = 0; i < splitted.length; i++) {
                    this.myProfileData.firstName = splitted[0];
                    this.myProfileData.lastName = splitted[1];
                }
            }
        
        this.photoImage = this._avatarCollectionService.getAllAvatars();
     
       // this.getProfilePicture();
        this.getPasswordComplexitySetting();

        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('Home')),
            new BreadcrumbItem(this.l('MyProfile'))
        ]));

      
    }

    SocialLoginVerify() {
        this._userServiceProxy.isCheckUserSocialLoginForWeb(abp.session.tenantId ? abp.session.tenantId: undefined, abp.session.userId).subscribe(res => {
         //   console.log('Social Value', res)
        this.isSocialNumber = res;
            if (this.isSocialNumber == 1) {
                this.isSocial = true;
            }
            else if (this.isSocialNumber == 2) {
                this.isSocial = false;

            }
            else if (this.isSocialNumber == 3) {
                this.isSocial = false;
            }

            else {
                this.isSocial = true;
            }
        })

    
    }

    close() {
        this._router.navigate(['/app/main/dashboard']);
    }


    async checkEmailIsValid(): Promise<number> {
        if (typeof this.newEmail !== 'undefined' && this.newEmail) {
            if (this.confirmEmail === this.newEmail) {
                let promise = new Promise<number>((resolve, reject) => {
                    this._profileService.checkEmail(this.newEmail).subscribe(res => {
                        if (res === true) {
                            this.message.warn(this.l('EmailAddressAlreadyExists'));
                            resolve(0);
                        } else {
                            resolve(1);
                        }
                    });
                });
                return await promise;
            }
            return 0;
         }
         return 2;
    }

    checkPasswordIsValid(): number {
        if (typeof this.newPassword !== 'undefined' && this.newPassword) {
            if (this.confirmPassword === this.newPassword) {
                return 1;
            }
            return 0;
         }
         return 2;
    }

    clearFormData() {
        this.newEmail = '';
        this.confirmEmail = '';
        this.showEmail = false;
        this.showPassword = false;
        this.newPassword = '';
        this.confirmPassword = '';
        this.currentPassword = '';
    }

    datadisplay() {
        this.newEmailId = '';
        this.confirmEmail = '';
        this.EmailCheck = false;
        this.isEmailNotsame = false;
        this.emailValidError = false;
        this.iscurrentPassword = false;
    }

    stopFormProcess() {
        this.saving = false;
        this.clicked = false;
        this.isLoading = false;
        this.spinnerService.hide();
    }
    EmailValid(){
        this.emailValidError=false;
    }
    emailValidError= false;
    incorrectCurrentPassword:boolean = false;
    async save() {
        
        let result = this.newPassword.localeCompare(this.confirmPassword);
        if(result == 0){
            this.matchPassword = true;
        }else{
            this.matchPassword = false;
        }
        if(this.myProfileForm.invalid){
            
            return;
        }
        //if(this.showEmail && this.confirmEmail.length==0){

        //    this.emailValidError =true;
        //    return;
        //}

        //if (this.showEmail && this.newEmailId.length == 0) {

        //    this.emailValidator = true;
        //    return;
        //}

        //if (this.confirmEmail.length && this.newEmailId.length > 0) {
        //    if (this.newEmailId !== this.confirmEmail) {
        //        this.isEmailNotsame = true;
        //        return;
        //    }
        //}

        //if (this.myProfileData.emailAddress == this.confirmEmail && this.newEmailId) {
        //    this.EmailCheck = true;
        //    return;
        //}




        this.isLoading = true;
        this.spinnerService.show();
        this.saving = true;
        this.clicked = true;
        if (this.myProfileData.firstName == null) { this.myProfileData.firstName = ''; }
        if (this.myProfileData.lastName == null) { this.myProfileData.lastName = ''; }
        this.myProfileData.fullName = this.myProfileData.firstName + ' ' + this.myProfileData.lastName;
        if (this.imageBase64 !== undefined) {
            this.imagePath = this.imageBase64;
        }

        let isEmailValid = await this.checkEmailIsValid();
        let isPasswordValid = this.checkPasswordIsValid();
        if (isEmailValid === 0) { this.stopFormProcess(); return; }
        if (isPasswordValid === 0) { this.stopFormProcess(); return; }

        //private _blobHelperServiceProxy: BlobHelperServiceProxy,
        let blobImgDto = new StoreImageOnBlobDto();
      
       // var reader = new FileReader();
            blobImgDto.tenantId = this.appSession.tenant.id;
            blobImgDto.imgBase64String = this.imagePath ? this.imagePath.split(',')[1] : null;
            
            this._blobHelperServiceProxy.getUrlAfterImageBlobStorage(blobImgDto).subscribe(imgLink => {
          
                this.myProfileData.imagePath = imgLink;
                localStorage.setItem('imagePath',this.myProfileData.imagePath);
                if (this.confirmEmail.length > 0) {
                    this.myProfileData.emailAddress = this.confirmEmail;

                }
               
                if (this.imagePath == '') {
                    this.myProfileData.imagePath = AppConsts.BackgroundImagephoto;
                }
                else {
                    this.myProfileData.imagePath = imgLink;
                }
              //  console.log('Profile Details', this.myProfileData.imagePath)
                
                this._profileService.editMyProfile(this.myProfileData).pipe(finalize(() => { this.saving = false; })).subscribe(() => {
                    if(isPasswordValid === 2 && isEmailValid === 2){
                        this.toastr.info(this.l('Changes updated successfully'));
                    }
                    if (isPasswordValid === 1) {
                        let input = new ChangePasswordInput();
                        input.currentPassword = this.currentPassword;
                        input.newPassword = this.newPassword;
                        this._profileService.changePasswordWithStatus(input)
                            .pipe(finalize(() => { this.saving = false; }))
                            .subscribe(result => {

                                if(result){
                                    this.toastr.info(this.l('Changes updated successfully'));
                                    this.isLoading = false;
                                    this.spinnerService.hide();
                                    localStorage.setItem('MyProfileDataSaved', 'true');
                                    this.close();
                
                                    this.topBarComponentData.myMethod();
                                   
                                    this.clearFormData();
                                    this.stopFormProcess();
                                }else{
                                    
                                    this.isLoading = false;
                                    this.incorrectCurrentPassword = true;
                                    this.spinnerService.hide();
                                }
                                
                              
                            });
                    }else{
                        this.isLoading = false;
                        this.spinnerService.hide();
                        localStorage.setItem('MyProfileDataSaved', 'true');
                        this.close();
                    }        

                    });
                
            })
        // this._profileService.editMyProfile(this.myProfileData).pipe(finalize(() => { this.saving = false; })).subscribe(() => {
        // if (isPasswordValid === 1) {
        //     let input = new ChangePasswordInput();
        //     input.currentPassword = this.currentPassword;
        //     input.newPassword = this.newPassword;
        //     this._profileService.changePassword(input)
        //         .pipe(finalize(() => { this.saving = false; }))
        //         .subscribe(result => {
        //             this.notify.info(this.l('YourPasswordHasChangedSuccessfully'));
        //         });
        // }

        // if (isEmailValid === 1) {
        // }
        //     this.isLoading = false;
        //     this.spinnerService.hide();
        //     this.toastr.info(this.l('SavedSuccessfully'));
        //     this.close();
        //     this.myProfileInfo();
        //     this.topBarComponentData.myMethod();
        //     this.clearFormData();
        //     this.stopFormProcess();
        // });
    }

    cancel() {
       // this.myProfileInfo();
        this.clearFormData();
        this.stopFormProcess();
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }


    toggleFieldTextTypeNewPassword() {
        this.fieldTextTypeNewPassword = !this.fieldTextTypeNewPassword;
    }

    toggleFieldTextTypeNewPasswordConfirm() {
        this.fieldTextTypeNewPasswordConfirm = !this.fieldTextTypeNewPasswordConfirm;

    }


    //public getfileContent(fileList: FileList) {
    //    const fileUpload = document.getElementById('UploadFile') as HTMLInputElement;
    //    let FileName = fileList[0].name;
    //    this.fileExtension = FileName.replace(/^.*\./, '');
    //    for (let index = 0; index < fileUpload.files.length; index++) {
    //        let reader = new FileReader();
    //        reader.onload = (e: any) => {
    //            this.imagePathModal = e.target.result;
    //            // this.logoInput.pictureImage = e.target.result;
    //        };
    //        reader.readAsDataURL(fileUpload.files[index]);
    //    }
    //    this.showImg = true;
    //    this.showImgModal = true;
    //}

   


    public getfileContent(fileList: FileList) {
       
        //if (fileList[0].size < 5242880) { if upload image size required pu all code here}
        const fileUpload = document.getElementById("UploadFile") as HTMLInputElement;
        let FileName = fileList[0].name;
        this.isImage = true;
        this.isImagepanel=false;
        this.fileExtension = FileName.replace(/^.*\./, '');
        if (!this.allowedPhotoFile.includes(this.fileExtension.toLocaleLowerCase())) {
            //show error
            this._messageService.error(this.l("Pleaseselectpngjpgorjpegformattouploadimage"));
            return;
        }
        for (let index = 0; index < fileUpload.files.length; index++) {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.imagePathModal = e.target.result;
            };
            reader.readAsDataURL(fileUpload.files[index]);
        }
     this.showImg = true;
     this.showImgModal = true;
    }

    cancelPhoto() {
        this.isSidebarOpen = false;
        this.showImgModal = false;
        this.imagePathModal = '';
        this.selectedAvatarIndex = -1;
    }

    deletePicture() {
     /*   this.isImage = false;
        this.selectedAvatarIndex = -1;
        this.imagePath = null;
        this.imagePathModal = null;
        this.showImg = true;
        this.savePhoto();
        //console.log('Image Details', this.imagePath)
       */
        this.selectedAvatarIndex = -1;
        this.imagePath = "";
        this.imagePathModal = "";
     
        this.isImage = true;
        this.isSidebarOpen = false;
       // this.savePhoto();
    }

   

    savePhoto() {
  
        this.imagePath = this.imagePathModal;
      //  console.log('Image on save', this.imagePath)
        this.isSidebarOpen = false;
        this.isImagepanel=true;
        this.isImage = true;
        this.showImgModal = false;
    }

    selectIcon(imgPath: string, index: number) {
        this.selectedAvatarIndex = index;
        this.isImage = true;
        this.imagePathModal = imgPath;
        this.imageBase64 = this.getBase64Image(document.getElementById('Img' + index));
        this.imagePathModal = this.imageBase64;
    }

    // getProfilePicture(): void {
    //     this._profileService.getProfilePicture().subscribe(result => {
    //         if (result && result.profilePicture) {
    //             this.imagePath = 'data:image/png;base64,' + result.profilePicture;
    //             this.showImg = true;
    //         }
    //     });
    // }

    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    getPasswordComplexitySetting() {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this._profileService.getPasswordComplexitySetting().subscribe(result => {
            this.passwordComplexitySetting = result.setting;
        });
    }

    onKey(tabIndex1): void {
        if (tabIndex1 === 1) {
            this.tabIndex = 1;
        } else if (tabIndex1 === 2) {
            this.tabIndex = 2;
        }
    }

    checkPassword(event) {
        const password = this.newPassword;
        const confirm_new_password = event.target.value;

        if (password !== undefined) {
            if (confirm_new_password !== password) {
                this.checkEmail = true;
            } else {
                this.checkEmail = false;
            }
        }
    }

    getBase64Image(img) {
        let canvas = document.createElement('canvas');
        canvas.width = img.width * 2;
        canvas.height = img.height * 2;
        let context = canvas.getContext('2d');
        context.drawImage(img, 0, 0, canvas.width, canvas.height);
        let dataURL = canvas.toDataURL('image/png', 1);
        return dataURL;
    }

    removeImage() {
        this.isImagepanel=true;
        this.showImgModal = false;
        this.deletePicture();
    }
    showSideBar() {
        this.isSidebarOpen = true;
    }


    logOutDevices() {
        this._appAuthService.logout();
    }

    currentPasswordChanged(){
        this.incorrectCurrentPassword = false;
    }
}
